export default "__VITE_ASSET__Civt9wW7__"